import React from 'react';
import { useTranslation } from 'react-i18next';
import './VisualSideContent.css';

const VisualSideContent = () => {
  const { t } = useTranslation();

  return (
    <div className="visual-side-content">
      <div className="left-side-info">
        <div className="info-item">
          <div className="info-icon">🛡️</div>
          <div className="info-content">
            <div className="info-title">
              {t('landing.benefits.protection.title')}
            </div>
            <ul className="info-list">
              <li className="info-desc">
                {t('landing.benefits.protection.point1')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.protection.point2')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.protection.point3')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.protection.point4')}
              </li>
            </ul>
          </div>
        </div>

        <div className="info-item">
          <div className="info-icon">📊</div>
          <div className="info-content">
            <div className="info-title">
              {t('landing.benefits.flexibility.title')}
            </div>
            <ul className="info-list">
              <li className="info-desc">
                {t('landing.benefits.flexibility.point1')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.flexibility.point2')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.flexibility.point3')}
              </li>
            </ul>
          </div>
        </div>

        <div className="info-item">
          <div className="info-icon">💰</div>
          <div className="info-content">
            <div className="info-title">
              {t('landing.benefits.efficiency.title')}
            </div>
            <ul className="info-list">
              <li className="info-desc">
                {t('landing.benefits.efficiency.point1')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.efficiency.point2')}
              </li>
              <li className="info-desc">
                {t('landing.benefits.efficiency.point3')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisualSideContent;

